import styled from 'styled-components';

export const LegalContainer = styled.div`
  max-width: 1200px;
  margin: 6rem auto;
  color: #172839;
  font-family: proxima-nova, sans-serif;

  @media (max-width: 768px) {
    margin: 2rem auto;
    padding: 0 1rem;
  }
`;

export const LegalHeading = styled.h3`
  font-family: proxima-nova, sans-serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 900;
  line-height: 125%;
  color: #172839;
`;

export const LegalSubheading = styled.h4`
  font-family: proxima-nova, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 140%;
  color: #172839;
  margin-top: 2rem;
`;
